export default {
  "*.dataset.line": function datasetLine() {
    var a = this,
        b = a.getClip('canvas'),
        c = a.getClip('init');
    return {
      "anchor.appearing": function anchorAppearing() {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      },
      "anchor.updating": function anchorUpdating() {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'plot'
        }];
      },
      "anchor.disappearing": function anchorDisappearing() {
        return [{
          finalAttr: {
            opacity: 0,
            "fill-opacity": 0,
            "stroke-opacity": 0
          },
          slot: 'plot'
        }];
      },
      "line.appearing": function lineAppearing() {
        return [{
          initialAttr: {
            "clip-rect": c
          },
          finalAttr: {
            "clip-rect": b
          },
          slot: 'middle',
          callback: function callback() {
            this.attr({
              "clip-rect": null
            });
          }
        }];
      },
      "line.updating": function lineUpdating() {
        return [{
          initialAttr: {
            opacity: 1,
            "clip-rect": c
          },
          finalAttr: {
            opacity: 1,
            "clip-rect": b
          },
          slot: 'plot'
        }];
      },
      "label.appearing": [{
        initialAttr: {
          opacity: 0
        },
        finalAttr: {
          opacity: 1
        },
        slot: 'final'
      }],
      "group.appearing": function groupAppearing(a) {
        return 'label-group' === a.attr.name ? [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }] : 'plot-group' === a.attr.name ? [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          startEnd: {
            start: .5,
            end: 1
          },
          slot: 'plot'
        }] : [{
          initialAttr: {
            opacity: 1
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      },
      "*": null
    };
  }
};